import { useHasRole } from '~/shared/context/use-has-role';

import { useJobArchitectureOptions } from '../api/use-job-architecture-options';

export type JobArchitectureReadAccess = 'pending' | 'readable' | 'unreadable';

/**
 * Whether the user may read the Job Architecture. A user holding a role that reads it does so at once; anyone else, such
 * as a transformation lead, an HR user or a manager who reaches the AI transformation dashboard through positions,
 * waits for the options to say.
 */
export const useJobArchitectureReadAccess = (): JobArchitectureReadAccess => {
    const readsJobArchitecture = useHasRole('job_architect', 'reviewer', 'viewer');
    const options = useJobArchitectureOptions();

    if (readsJobArchitecture) return 'readable';
    if (options.isError) return 'unreadable';
    if (options.data === undefined) return 'pending';

    return options.data.canRead ? 'readable' : 'unreadable';
};
